import { APP_VERSION } from "@/version";

export const PoweredBy = ({ className = "" }) => (
  <div className={`flex flex-wrap items-center justify-between gap-x-4 gap-y-1 text-xs text-slate-400 ${className}`} data-testid="powered-by-footer">
    <p>
      Havnekalkulator.no er et produkt fra{" "}
      <a href="https://promonorge.no" target="_blank" rel="noopener noreferrer" className="text-slate-500 underline-offset-2 hover:text-sky-700 hover:underline" data-testid="promonorge-link">
        Promonorge.no
      </a>
    </p>
    <span className="ml-auto font-num tabular-nums" title="Versjon av appen" data-testid="app-version">Versjon {APP_VERSION}</span>
  </div>
);
